module.exports = __webpack_public_path__ + "static/media/euro-sign.a2d499fc.svg";